import { gql } from 'graphql-tag';

export type RawCustomFieldValue = {
  id: string;
  name: string;
  archiveDate: string;
};

export type LoadCustomFieldValuesByIdsRawResponse = {
  company: {
    customFields: Array<
      | {
          __typename: 'CustomFieldList';
          values: { edges: { node: RawCustomFieldValue }[] };
        }
      | {
          __typename: 'CustomFieldBoolean';
          booleanValues: Array<{ id: string; name: boolean }>;
        }
    >;
  };
};

export const LOAD_CUSTOM_FIELDS_VALUES_BY_IDS_MULTIPLE = gql`
  query Idd3a9c30e343d2319e9356216fc58bab7(
    $companyId: ID!
    $customFieldIds: [ID!]!
    $customFieldValueIds: [ID!]!
  ) {
    __typename
  }
`;
